
import MyImporter from './myImporter';
export default {
  myImporter: [ 'type', MyImporter ]
};